import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { doProductMobx, productSaleMobx } from 'restaurant'
import { useHistoryNew } from '@utils'
import { SingleChoose, SingleChooseItem, MultiChoose, MultiChooseItem } from '@cps'
import CashierController from '@ctrls/cashierController'
import { MultiModify } from '../'
import './index.scss'

interface IProps {
  singleNo: string; // 单选组展开
  onClick: (groupsNo: string) => void;
  wrongFlag: boolean;
}

const AboardModify: FC<IProps> = ({ singleNo, onClick, wrongFlag }) => {
  return (
    <div className={`choose-modify-list ${doProductMobx.doProduct.saleCnt === 0 ? 'sold-out' : ''}`}>
      {
        doProductMobx.doProduct.modifierGroups.map(groups => {
          return groups.mode === 'single' || groups.mode === 'multiSingle' ? (
            groups.modifiers.length > 9 ? (
              <div
                key={groups.no}
                className='to-choose-tip'
                data-cypid={`to-choose-tip_${groups?.no}`}
                onClick={() => {
                  doProductMobx.recordModifierGroup(groups.no)
                  CashierController.openModifierDetail(groups.no, { isModal: true })
                }}
              >
                <div className='selected-list'>
                  <i className='iconfont icon-a-shenglvehao1'></i>
                </div>
                <i className='iconfont icon-chevron-right'>
                </i>
              </div>
            ) : (
              <SingleChoose
                isShow
                key={groups.no}
                name={groups.name}
                onClick={() => onClick(groups.no)}
                choosedName={groups.selectMin === groups.selectMax ? i18n.t('productdetail.requireCount', { count: groups.selectMin }) : groups.cnt < groups.selectMin ? i18n.t('productdetail.minCount', { count: groups.selectMin }) : i18n.t('productdetail.optional', { count: groups.selectMax })}
                isWrong={wrongFlag && !groups.isReady}
              >
                {
                  groups.modifiers.map(modify => {
                    const saleCnt = productSaleMobx.localScaleNoToCntMap[`${modify.no}_0`]
                    const stopSale = saleCnt && saleCnt.cnt === 0
                    return (
                      <SingleChooseItem
                        className={modify.cnt ? 'selected' : ''}
                        key={modify.no}
                        data={{ name: modify.name, no: modify.no, price: modify.price, notSale: stopSale, saleCnt: saleCnt?.cnt }}
                        onClick={(e) => {
                          e.stopPropagation()
                          !stopSale && doProductMobx.selectModifier(groups.no, modify.no)
                        }}
                      />
                    )
                  })
                }
              </SingleChoose>
            )
          ) : (
            <MultiModify key={groups.no} group={groups} />
          )
        })
      }
    </div>
  )
}

export default observer(AboardModify)
